/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_EmptyInputs */

const vi_my_grower_empty = /** @type {(inputs: My_Grower_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn chưa được gắn với hộ nào. Vui lòng liên hệ cán bộ nông nghiệp.`)
};

/**

* @param {My_Grower_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_empty = /** @type {((inputs?: My_Grower_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_empty(inputs)
});